export default {
  SET_STANDARD_TASKS(state, standardTasks) {
    state.standardTasks = standardTasks;
  },
  BUMP_STANDARD_TASKS_LIST_CACHE_VERSION(state) {
    state.standardTasksListCacheVersion += 1;
  },
  ADD_STANDARD_TASK(state, standardTask) {
    state.standardTasks.unshift(standardTask);
  },
  UPDATE_STANDARD_TASK(state, standardTask) {
    const index = state.standardTasks.findIndex(
      (item) => item._id === standardTask._id
    );
    if (index !== -1) {
      state.standardTasks.splice(index, 1, {
        ...state.standardTasks[index],
        ...standardTask,
      });
    }
  },
  REMOVE_STANDARD_TASK(state, id) {
    state.standardTasks = state.standardTasks.filter(
      (standardTask) => standardTask._id !== id
    );
  },
};
